import * as FiIcons from "react-icons/fi";

export const navigation = [
  { label: "Dashboard", path: "/", icon: FiIcons.FiGrid },
  { label: "Needs attention", path: "/attention", icon: FiIcons.FiAlertCircle },
  { label: "Expenses", path: "/expenses", icon: FiIcons.FiCreditCard },
  { label: "Receipt inbox", path: "/receipt-inbox", icon: FiIcons.FiMail },
  { label: "Reminders", path: "/reminders", icon: FiIcons.FiBell },
  { label: "Accountant requests", path: "/accountant/requests", icon: FiIcons.FiMessageSquare },
  { label: "Bank statements", path: "/banking", icon: FiIcons.FiColumns },
  { label: "Cash flow", path: "/cash-flow", icon: FiIcons.FiCalendar },
  { label: "Income", path: "/income", icon: FiIcons.FiTrendingUp },
  { label: "Invoices", path: "/invoices", icon: FiIcons.FiFileText },
  { label: "Repayments", path: "/repayments", icon: FiIcons.FiDollarSign },
  { label: "Trips", path: "/trips", icon: FiIcons.FiMapPin },
  { label: "Vehicles", path: "/vehicles", icon: FiIcons.FiTruck },
  { label: "Contractors", path: "/contractors", icon: FiIcons.FiUsers },
  { label: "Tax Centre", path: "/tax", icon: FiIcons.FiFileText },
  { label: "Review", path: "/review", icon: FiIcons.FiCheckSquare },
  { label: "Support", path: "/support", icon: FiIcons.FiHelpCircle },
  { label: "Feature requests", path: "/features", icon: FiIcons.FiZap },
  { label: "Production health", path: "/settings/health", icon: FiIcons.FiActivity },
  { label: "Settings", path: "/settings", icon: FiIcons.FiSettings },
];

export const mileageNavigationPaths = new Set([
  '/',
  '/trips',
  '/vehicles',
  '/support',
  '/features',
  '/settings'
]);

export function filterNavigationGroupsForMileage(groups) {
  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => mileageNavigationPaths.has(item.path))
    }))
    .filter((group) => group.items.length > 0);
}

export function resolveOwnerNavigationGroups(groups, {isPlanResolved, isMileagePlan}) {
  return isPlanResolved && !isMileagePlan
    ? groups
    : filterNavigationGroupsForMileage(groups);
}

// Display groups reuse the existing route objects so every destination is preserved.
export const navigationGroups = [
  { label: "Overview", paths: ["/", "/attention", "/reminders", "/accountant/requests"] },
  {
    label: "Financial records",
    paths: [
      "/expenses",
      "/receipt-inbox",
      "/banking",
      "/cash-flow",
      "/income",
      "/invoices",
      "/contractors",
      "/repayments",
    ],
  },
  {
    label: "Business operations",
    paths: ["/trips", "/vehicles"],
  },
  { label: "Reporting & settings", paths: ["/review", "/tax", "/features", "/support", "/settings/health", "/settings"] },
].map((group) => ({
  label: group.label,
  items: group.paths.map((path) =>
    navigation.find((item) => item.path === path),
  ),
}));

export const accountantNavigationGroups = [
  {
    label:"Accountant workspace",
    items:[
      {label:"Overview",path:"/",icon:FiIcons.FiGrid},
      {label:"Requests",path:"/accountant/requests",icon:FiIcons.FiMessageSquare},
      {label:"Monthly review",path:"/review",icon:FiIcons.FiCheckSquare},
      {label:"Support",path:"/support",icon:FiIcons.FiHelpCircle},
      {label:"Feature requests",path:"/features",icon:FiIcons.FiZap},
      {label:"Profile",path:"/settings/profile",icon:FiIcons.FiUser}
    ]
  }
];

